const fr = {
    9000001:"Trophée de Noël 2023",
    9000002:"Championnat de Futures SuperEx",
    9000003:"gagnez 30,000 USDT en prix de compétition ",
    9000004:"Nombre de participants",
    9000005:"Cagnotte débloquée (USDT)",
    9000006:"Qualification pour le classement du volume de transactions ",
    9000007:"Qualifications basées sur le Classement du Taux de Profit",
    9000008:"Compétition de qualification pour le classement des profits ",
    9000009:`Compétition de classement du volume de transactions : Débloquez la plus haute récompense de <span style="color: #ffc72b;">20,000</span> USDT dans la cagnotte bonus`,
    9000010:"Selon le nombre de participants, plus le nombre de participants est élevé, plus la cagnotte sera débloquée, jusqu'à 20 000 USDT",
    9000011:"Montant du fonds de prix",
    9000012:"Mises à jour quotidiennes à 10:00 (UTC) pendant l'événement",
    9000013:"Estimation des récompenses",
    9000014:"Volume total des transactions sur les contrats à terme pendant la période",
    9000015:"Règles des récompenses",
    9000016:"Selon le nombre de participants, plus le nombre de participants est élevé, plus la cagnotte sera débloquée, jusqu'à 20 000 USDT",
    9000017:"Montant du fonds de prix (USDT)",
    9000018:"Classement du taux de profit de l'événement",
    9000019:"Inscription",
    9000020:"Classement du montant des profits de l'événement",
    9000021:"Terminé",
    9000022:`Concours de classement par taux de profit, partagez un fonds de prix de <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000023:`Compétition de classement des profits - Profitez de la prime de <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000024:"Taux de profit cumulé sur les contrats à terme",
    9000025:"Montant total des profits accumulés",
    9000026:"Pas Commencé",
    9000027:"Les 50 meilleurs participants de la compétition de classement des profits seront récompensés. Pour plus de détails, veuillez vous référer aux règles de récompense pour le classement afin d'obtenir les récompenses",
    9000028:"Les 50 premiers du classement en taux de profit des utilisateurs participants peuvent recevoir des prix, voir les règles de récompense basées sur le classement des transactions",
    9000029:"Classement du volume de transactions de l'événement",
    9000030:"inscription réussi",
    9000031:"Télécharger l'application",
    9000032:"Retour à la page d'accueil",

    //合约交易积分
    9100001: 'Enregistrer des Points',
    9100002: 'Obtenir un Airdrop',
    9100003: 'Échanger des Récompenses',
    9100004: 'Solde des Points',
    9100005: 'Détails',
    9100006: 'Points de Connexion',
    9100007: 'Points de Trading',
    9100008: `Points d'Invitation`,
    9100009: 'Points Bonus',
    9100010: 'Tirage au Sort',
    9100011: 'Obtenez des points',
    9100012: 'Règles des Points',
    9100013: 'Détails des points',
    9100014: 'Vous devez vous inscrire pour participer à cet événement. Cliquez pour vous inscrire',
    9100015: 'A tradé pendant {day} jours consécutifs et gagné {num} points',
    9100016: `Points gagnés aujourd'hui {num}`,
    9100017: 'Fond de Prix en Points',
    9100018: 'Chaque tirage au sort consomme {point} points, et un maximum de {num} tirages au sort peut être effectué par jour.',
    9100019: `Nombre de tirages au sort aujourd'hui`,
    9100020: 'Utilisateur',
    9100021: 'Points',
    9100022: 'Le solde des points est insuffisant',
    9100023: 'Le solde des points est insuffisant. Veuillez obtenir des points avant de participer au tirage au sort.',
    9100024: 'Le nombre de tirages au sort a atteint sa limite !',
    9100025: `Le nombre de tirages au sort pour aujourd'hui a atteint sa limite. Réessayez demain.`,
    9100026: 'Comment obtenir des points',
    9100027: `Inscrivez-vous pour participer à l'activité de gain de points de trading de contrats à terme afin de gagner des points.`,
    9100028: 'Inscription réussie',
    9100029: `Vous vous êtes inscrit pour participer à l'activité de trading de contrats à terme afin de gagner des points. Allez et tradez pour gagner plus de points (vous ne bénéficierez plus des commissions et des remises en argent)`,
    9100030: 'Après avoir annulé votre inscription, vous ne recevrez plus de points. Êtes-vous sûr de vouloir annuler votre inscription ?',
    9100031: `Centre d'Activités des Points de Trading`,
    9100032: 'Obtenez des points',
    9100033: 'Vous devez vous inscrire pour participer à cet événement. Cliquez pour vous inscrire',
    9100034: 'Vous pouvez gagner des points en tradant des contrats à terme de manière continue',
    9100035: 'Les utilisateurs peuvent gagner des points pour tous leurs échanges de contrats à terme',
    9100036: 'Points du classement',
    9100037: 'Les cinq premiers utilisateurs du classement des échanges quotidiens recevront des points bonus supplémentaires',
    9100038: `Les utilisateurs invités reçoivent des points et l'invitant peut recevoir des points bonus.`,
    9100039: '{guy} Déjà gagné<span style="color:#D9A31A"> {num} points!</span>',
    9100040: 'Essayez la Loterie Maintenant !',
    9100041: 'Félicitations pour avoir obtenu',
    9100042: 'Tous les types',
    9100043: 'Restez sur cette page',
    9100044: 'Inscrivez-vous pour participer',
    9100045: 'Continuez à trader',
    9100046: `Il n'y a actuellement aucune activité en cours. Restez à l'affût des dernières nouvelles...`,
    9100047: 'Échanger des jetons SCS',
    9100048: '',
    9100049: '',

    9100050: 'Dates',
    9100051: 'Sélectionner une date de début',
    9100052: 'Sélectionner une date de fin',
    9100053: 'à',
    9100054: 'Type',

    9100055: 'Points gagnés = volume de trading * 1% (la difficulté sera ajustée au fur et à mesure que le volume total de trading de la plateforme augmente)',
    9100056: `Par exemple : si l'utilisateur utilise une position avec une marge de 100 USDT*100X=10000 USDT`,
    9100057: `alors vous n'avez besoin que d'un dépôt de 100 USDT pour obtenir 100 points.`,
    9100058: `Les points de trading sont le seul moyen d'obtenir le token de plateforme SCS`,
    9100059: 'Points bonus supplémentaires = total des points de la journée * ratio de récompense de classement.',
    9100060: 'Rang',
    9100061: 'Première place',
    9100062: 'Deuxième place',
    9100063: 'Troisième place',
    9100064: 'Quatrième place',
    9100065: 'Cinquième place',
    9100066: `Les utilisateurs invités reçoivent des points et l'invitant peut recevoir des points bonus.`,
    9100067: 'Facteur de niveau',
    9100068: `Formule de calcul : points de parrainage obtenus = points obtenus par l'invité * coefficient de niveau`,
    9100069: 'Le coefficient de niveau sera ajusté selon la situation réelle.',
    9100070: `Par exemple : l'utilisateur B participe à une activité de points, et son invitant est l'utilisateur A, et le nombre d'invitations de l'utilisateur A a atteint le niveau 3. L'utilisateur B a accumulé des points = 360 000;`,
    9100071:`Alors les points de promotion cumulés que l'utilisateur A peut obtenir = 360 000 * 30% = 108 000`,
    9100072:'coefficient de récompense',
    9100073:'1 Utilisateurs de trading',
    9100074:'Le volume de trading atteint 5 millions',
    9100075:'Le volume de trading atteint 20 millions',

    9100076:'Transfert',
}
export default fr



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/fr.js